import { useQueryClient } from "@tanstack/react-query";
import { ManualSchedulingDrawer } from "components/ManualScheduling/ManualSchedulingDrawer/ManualSchedulingDrawer";
import { Button, Tabs } from "components/styleguide";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { refreshAttendeeItineraryQueries } from "./helpers";
import ItineraryTab from "./IntineraryTab";
import RemovedBookingsTab from "./RemovedBookingsTab";

import styles from "./styles.module.less";

interface AttendeeItineraryProps {
  forumId: number;
  attendeeId: number;
}

const AttendeeItinerary = ({ forumId, attendeeId }: AttendeeItineraryProps) => {
  const { t } = useTranslation();

  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  const tabs = [
    {
      label: t("Itinerary"),
      key: "itineraryTab",
      children: <ItineraryTab />,
    },
    {
      label: t("Removed Bookings"),
      key: "removedBookingsTab",
      children: <RemovedBookingsTab forumId={forumId} attendeeId={attendeeId} />,
    },
  ];

  const queryClient = useQueryClient();

  const handleAddToConfSubmitted = () => {
    refreshAttendeeItineraryQueries(queryClient);
  };

  return (
    <div className={styles.itinerarySection}>
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button onClick={() => setIsDrawerVisible(true)}>{t("Add To Conf. Session")}</Button>
      </div>

      <ManualSchedulingDrawer
        visible={isDrawerVisible}
        onClose={() => setIsDrawerVisible(false)}
        defaultAttendeeId={attendeeId}
        onFinish={handleAddToConfSubmitted}
      />

      <Tabs items={tabs} />
    </div>
  );
};

export default AttendeeItinerary;
